import React, { useState } from 'react';
import { PlayCircle, Trash2 } from 'lucide-react';
import { useRecordingStream } from '../../lib/recordings.js';

/** Inline <audio> (right-click to download); mounted only once the user opens it. */
function InlinePlayer({ callId }) {
  const { url, status } = useRecordingStream(callId);
  if (status === 'loading') return <div className="text-xs text-white/40">Loading recording…</div>;
  if (status === 'error' || !url) return <div className="text-xs text-rose-300/80">Recording unavailable.</div>;
  return (
    <div>
      <audio controls autoPlay preload="none" src={url} className="h-9 max-w-[260px]" data-testid="inline-audio" />
      <div className="text-[10px] text-white/40 text-center">Right-click player to download</div>
    </div>
  );
}

/**
 * "PLAY RECORDING" button that swaps to an inline audio player, plus a trash
 * icon that deletes the recording.
 * @param {{callId: string, onDelete: (callId: string) => void, deleting?: boolean}} props
 * @returns {JSX.Element}
 */
export default function AudioPlayer({ callId, onDelete, deleting = false }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="flex items-center justify-end gap-2">
      {open ? (
        <InlinePlayer callId={callId} />
      ) : (
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-civix-purple/60 text-civix-purpleSoft text-xs font-semibold tracking-wide hover:bg-civix-purple/10"
        >
          <PlayCircle className="w-4 h-4" /> PLAY RECORDING
        </button>
      )}
      <button
        type="button"
        onClick={() => onDelete(callId)}
        disabled={deleting}
        aria-label="Delete recording"
        title="Delete recording"
        className="p-1.5 text-rose-400 hover:text-rose-300 disabled:opacity-40"
      >
        <Trash2 className="w-4 h-4" />
      </button>
    </div>
  );
}
